// extracted by mini-css-extract-plugin
export default {"defaultInitials":"AssetLogo_defaultInitials__38RO7"};